export type Clock = number[]

class UMath {
  static deg2rad = (degrees: number): number => {
    return degrees * (Math.PI / 180)
  }
  static diffYears = (dt2: Date, dt1: Date) => {
    let diff = (dt2.getTime() - dt1.getTime()) / 1000
    diff /= 60 * 60 * 24
    return Math.abs(Math.round(diff / 365.25))
  }
  static clock = (): Clock => {
    const date = new Date()
    let hourOffset = 3
    date.setUTCHours(date.getUTCHours(), date.getUTCMinutes())
    const time = date.getTime()
    date.setUTCFullYear(date.getUTCFullYear(), 2, 22)
    const dstStart = date.getTime()
    date.setUTCFullYear(date.getUTCFullYear(), 8, 22)
    const dstEnd = date.getTime()
    if (time > dstStart && time < dstEnd) hourOffset = 4
    date.setUTCHours(date.getUTCHours() + hourOffset, date.getUTCMinutes() + 30)
    return [date.getUTCHours(), date.getUTCMinutes()]
  }
}

export default UMath
